import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, HostBinding, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TeaserBetConfig } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

import { IBetslipDigitalRootState } from '../../../../digital/state';
import { betslipTeaserBetsStateSelector } from '../../state';

@Component({
    selector: 'bs-teaser-bet-summary-container',
    templateUrl: './teaser-bet-summary-container.component.html',
    styleUrls: ['./teaser-bet-summary-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TeaserBetSummaryContainerComponent implements OnInit {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @HostBinding('class.epcot-enabled') epcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.Betslip);
    @HostBinding() class = 'teaser-bet-summary-container';

    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private store: Store<IBetslipDigitalRootState>,
        private teaserBetConfig: TeaserBetConfig,
        private changeDetectorRef: ChangeDetectorRef,
        private epcotConfigService: EpcotConfigService,
    ) {}

    ngOnInit(): void {
        if (this.teaserBetConfig.isEnabled) {
            this.store
                .select(betslipTeaserBetsStateSelector)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((_) => {
                    this.changeDetectorRef.detectChanges();
                });
        }
    }
}
